import React from 'react';
import { makeStyles } from '@mui/styles';
import  {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

const useStyles = makeStyles((theme) => ({
  gridMargin : {
    marginLeft: 20
  },
  formControl: {
    minWidth: 200,
    marginTop: 2.5
  },
  select: {
    zIndex: 1202
  },
  centeredGridText: {
    textAlign: 'center'
  },
  button: {
    marginTop: 5,
    marginBottom: 10,
    height: '48px',
  }
}));

const VariableTimeline = ({ options, year, number, onChangeTimelineDays, onChangeTimelineFrom, onSave }) => {
  const classes = useStyles();
  const [days, setDays] = React.useState(year?.[`timeline_days_${number}`]||'');
  const [from, setFrom] = React.useState(year?.[`timeline_from_${number}`]);

  const handleDaysChange = (e) => {
    const { value } = e.target;
    var rx = /^\d+$/;
    if(rx.test(value) || value === '') {
      setDays(event.target.value);
    }
  };

  const handleChangeDateOptions = (event) => {
    setFrom(event.target.value);
  };

  const handleSave = () => {
    onChangeTimelineDays(days);
    onChangeTimelineFrom(from);
    onSave();
  };
  
  return (
    <>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        className={classes.gridMargin}
      >
        <Grid item xs={3}>
          <TextField
            placeholder="Days"
            id="outlined-size-small"
            defaultValue=""
            variant="outlined"
            size="small"
            value={days}
            onChange={handleDaysChange}
          />
        </Grid>
          <Grid item xs={2} className={classes.centeredGridText}>
            <Typography variant="body1">From:</Typography>
          </Grid>
        <Grid item xs={7}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              placeholder="Status"
              id="demo-simple-select-outlined"
              value={from}
              onChange={handleChangeDateOptions}
              className={classes.select}
            >
              {options.map((row) => (
                <MenuItem value={row.id} key={row.id}>{row.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            startIcon={<SaveIcon />}
            onClick={handleSave}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default VariableTimeline;